import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import moment from 'moment-timezone';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-referee-card',
  templateUrl: './referee-card.component.pug',
  styleUrls: ['./referee-card.component.scss'],
  standalone: false
})
export class RefereeCardComponent implements OnInit {
  @Input() referee: any;
  @Input() workHistoryStart: any;
  @Input() workHistoryEnd: any;
  @Output() viewReportClick = new EventEmitter<any>();
  coverageStart: any;
  coverageEnd: any;
  coverageOffset: any;
  coverageWidth: any;
  unusualActivityDetectedTooltip: string = $localize`Unusual activity detected`;
  markedAsSuspiciousTooltip: string = $localize`Marked as suspicious`;
  refereeStateMap = {
    'requested':{
      'label': $localize`Sent`,
      'class': 'requested'
    },
    'accessed':{
      'label': $localize`Accessed`,
      'class': 'in_progress'
    },
    'started':{
      'label': $localize`Accessed`,
      'class': 'in_progress'
    },
    'agreed':{
      'label': $localize`Accessed`,
      'class': 'in_progress'
    },
    'verified':{
      'label': $localize`Accessed`,
      'class': 'in_progress'
    },
    'saved':{
      'label': $localize`Saved`,
      'class':'in_progress'
    },
    'declined':{
      'label': $localize`Declined`,
      'class':'expired'
    },
    'unobtainable':{
      'label': $localize`Unobtainable`,
      'class':'expired'
    },
    'answered':{
      'label': $localize`Answered`,
      'class':'complete'
    },
    'confirmed':{
      'label': $localize`Confirmed`,
      'class':'complete'
    },
  }

  constructor(private permissions: PermissionsService) { }

  ngOnInit(): void {
    const whStart = this.format_date(this.workHistoryStart);
    const whEnd = this.format_date(this.workHistoryEnd);
    this.coverageStart = this.format_date(this.referee['referee_start_date']);
    this.coverageEnd = this.format_date(this.referee['referee_end_date']);
    const fullWidth = this.calculateDifference(whStart,whEnd);
    const width = this.calculateDifference(this.coverageStart,this.coverageEnd);
    const leftOffset = this.calculateDifference(whStart,this.coverageStart);
    this.coverageWidth = ''+String(width/fullWidth * 100)+'%';
    this.coverageOffset = ''+String(leftOffset/fullWidth * 100)+'%';
  }

  get refereeNameTooltip(): string {
    return this.referee?.name?.length > 40 ? this.referee.name : '';
  }

  get truncatedRefereeName(): string {
    if (!this.referee?.name) return '';
    return this.referee.name.length > 40
      ? this.referee.name.substring(0, 40) + '...'
      : this.referee.name;
  }

  get roleAtOrgTooltip(): string {
    const fullText = `${this.referee?.role || ''} at ${this.referee?.company_name || ''}`;
    return fullText.length > 40 ? fullText : '';
  }

  get truncatedRoleAtOrg(): string {
    if (!this.referee?.role || !this.referee?.company_name) return '';
    const fullText = `${this.referee.role} at ${this.referee.company_name}`;
    return fullText.length > 40
      ? fullText.substring(0, 40) + '...'
      : fullText;
  }

  format_date(date_dict: any) {
    return moment(date_dict.year+'-'+ date_dict.month +'-'+ date_dict.day, "YYYY-MM-DD").format('DD MMM YYYY');
  }

  calculateDifference(startDate, endDate) {
    var start = new Date(startDate);
    var end = new Date(endDate);
    return Math.floor((end.getTime() - start.getTime()) / 1000 / 60 / 60 / 24);
  }

  onViewReportClick() {
    this.viewReportClick.emit(this.referee);
  }

}
